import { Card as NextUICard, CardProps } from "@heroui/card";
import clsx from 'clsx';
import React from 'react';

const Card = ({
  shadow = 'none',
  radius = 'md',
  children,
  className,
  ...props
}: CardProps) => {
  return (
    <NextUICard
      {...props}
      shadow={shadow}
      radius={radius}
      className={clsx('border-gray-medium2', className)}
    >
      {children}
    </NextUICard>
  );
};

Card.displayName = 'Card';
export default Card;
